import { render, staticRenderFns } from "./prizeListAction.vue?vue&type=template&id=73c864cb&"
import script from "./prizeListAction.vue?vue&type=script&lang=js&"
export * from "./prizeListAction.vue?vue&type=script&lang=js&"
import style0 from "./prizeListAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports